import React from 'react';
import HeaderTitle from 'header/components/title';

const Header = () => (
  <HeaderTitle title="Reset Your Password" />
);

export default Header;



// WEBPACK FOOTER //
// ./login/components/password_reset_header.jsx